import { FC, useCallback, useEffect, useState } from "react";
import HighCharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { useLocation } from "react-router-dom";

import {
    PIE_CHART_OPTIONS,
} from "src/constants/highCharts";
import { wrapperFunctionPieChart } from "src/helpers";
import CustomTopPayorList from "../customTopPayorList";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { top_payors_details_multiple } from "src/pages/manufacturer/types";



const InsurancePayorDetail: FC<StatisticsObjectType> = ({ StatisticsObjectType}): JSX.Element => {
  const [data, setData] = useState({});
  const [dataPA, setPAData] = useState({});

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const InsuranceName = params.get('insurance_name');

  const populatePAPieChart = useCallback(() => {
    const cvgOptions = {
      ...PIE_CHART_OPTIONS,
      series: wrapperFunctionPieChart((StatisticsObjectType.top_payors_details as top_payors_details_multiple).cvg)
    };
    setPAData(cvgOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(StatisticsObjectType.top_payors_details as top_payors_details_multiple).cvg]);

  useEffect(() => {
    populatePAPieChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [populatePAPieChart]);

  const populateCvgPieChart = useCallback(() => {
    const cvgOptions = {
      ...PIE_CHART_OPTIONS,
      series: wrapperFunctionPieChart((StatisticsObjectType.top_payors_details as top_payors_details_multiple).pa_req)
    };
    setData(cvgOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(StatisticsObjectType.top_payors_details as top_payors_details_multiple).pa_req]);

  useEffect(() => {
    populateCvgPieChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [populateCvgPieChart]);


  return (
    <div className="card">
      <div className="card-header">
        <h4 className="m-0 text-center">Top Payer Details</h4>
      </div>

      <div className="card-body p-0">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-4">
            <CustomTopPayorList StatisticsObjectType={StatisticsObjectType}/>
          </div>

          <div className="col-12 col-sm-12 col-md-8">
            <h3 className="text-center fw-bold mb-3">Plan: {InsuranceName}</h3>

            <div className="row">
              <div className="col-6">
                <div className="text-center mb-2">
                  <h4>Med/Rx Coverage</h4>
                </div>
                <HighchartsReact highcharts={HighCharts} options={data} />
              </div>
              <div className="col-6">
                <div className="text-center mb-2">
                  <h4>Precert/PA Detected</h4>
                </div>
                <HighchartsReact highcharts={HighCharts} options={dataPA} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsurancePayorDetail;
